import styled from 'styled-components';

import { modularScale, pxToRem } from '../../utils';
import { palette } from '../../theme';

export const DropdownItem = styled.div`
  padding: ${pxToRem(11.5)} ${modularScale()};
  cursor: pointer;
  &:hover {
    background: ${palette.brand.grey};
  }
  &:first-child {
    border-radius: ${modularScale(-2)} ${modularScale(-2)} 0 0;
  }
  &:last-child {
    border-radius: 0 0 ${modularScale(-2)} ${modularScale(-2)};
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${palette.grayscale.shade300};
  }
`;
